import {Component, ChangeDetectionStrategy} from '@angular/core';
import {sendCommand, sendQuery} from '../../common/utils';
import {
  BezoekschipOrganisation,
  FindOrganisations,
  UpsertOrganisationSettings,
  VisitSummary
} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../refdata/portvisit-utils";
import {QueryOptions} from "../../common/query-gateway";
import {VisitContext} from "../../visit-details/visit-context";
import {ConsignmentUtils} from "../../new-portvisit/consignments/consignment.utils";

@Component({
    selector: 'organisation-settings',
    templateUrl: './organisation-settings.html',
    styleUrls: ['./organisation-settings.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrganisationSettings {
  protected organisation: BezoekschipOrganisation;
  protected visits: VisitSummary[];

  searchOrganisation = (term: string) => sendQuery('com.portbase.bezoekschip.common.api.authorisation.FindOrganisations',
    <FindOrganisations>{term}, <QueryOptions>{caching: false});

  setOrganisation = (organisation: BezoekschipOrganisation) => {
    this.organisation = organisation;
    if (!organisation) {
      return;
    }

    if (!this.organisation.settings) {
      this.organisation.settings = {}
    }

    const settings = this.organisation.settings;
    settings.tsdPilotCrns = settings.tsdPilotCrns ?? [];
    settings.tsdTimeFirstIcs2Visit = settings.tsdTimeFirstIcs2Visit ?? null;

    this.visits = this.organisation.settings.tsdPilotCrns.map(crn => ({crn})) ?? [];
  }

  pilotCrnsChanged(visitSummaries: VisitSummary[]) {
    this.organisation.settings.tsdPilotCrns = visitSummaries.map(visit => visit.crn);
  }

  sendUpsertOrganisationSettings() {
    const type = "com.portbase.bezoekschip.common.api.accountmanagement.UpsertOrganisationSettings";
    sendCommand(type, <UpsertOrganisationSettings>{
      shortName: this.organisation.shortName,
      settings: this.organisation.settings,
    });
  }

  protected readonly utils = PortvisitUtils;
  protected readonly consignmentUtils = ConsignmentUtils;
  protected readonly context = VisitContext;
}
